import { render, staticRenderFns } from "./OrderStatusPreparingIcon.vue?vue&type=template&id=09721b1f&scoped=true&"
import script from "./OrderStatusPreparingIcon.vue?vue&type=script&lang=js&"
export * from "./OrderStatusPreparingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09721b1f",
  null
  
)

export default component.exports